import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const ContainerDatePicker = styled.div`
  width: 100% !important;
  padding: 16px;
  background: ${theme.palette.secondary.main};
`;
